<template>
  <div>
    <div class="logo-container">
      <img src="../../assets/geat-logo.png" />
    </div>
    <div class="success-container">
      <img src="../../assets/icon-success.png" />
      <div class="label">{{ $t("register.success") }}</div>
    </div>

    <div class="content">
      <div>{{ $t("register.congratulations") }}</div>
      <div>
        {{ $t("register.number") }}：<span>{{ storeSerial }}</span>
      </div>
    </div>

    <!-- <div class="downlaod-btn">{{ $t("register.login") }}</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      storeSerial: this.$route.query.storeSerial
    };
  },

  created() {},

  methods: {}
};
</script>

<style scoped lang="sass" src="./success.sass"></style>
